import React, {FC, useMemo} from 'react';
import {makeStyles} from '@material-ui/core';
import {Container, Icon, Label, Row, Tooltip, Wrapper} from 'components-lib';
import {Form} from 'forms';
import {IWithDisabled} from 'models';

interface IYesNoOption {
  label: string;
  value: boolean | string | number;
}

interface IYesNoRadioGroupProps extends IWithDisabled {
  name: string;
  label: string;
  options?: IYesNoOption[];
  infoText?: string;
}

const defaultYesNoOptions: IYesNoOption[] = [
  {label: 'Yes', value: 'true'},
  {label: 'No', value: 'false'},
];

export const YesNoRadioGroup: FC<IYesNoRadioGroupProps> = ({
  name,
  label,
  disabled,
  options = defaultYesNoOptions,
  infoText,
}) => {
  const classes = useStyles();

  const radioOptions = useMemo(() => options, [options]);

  return (
    <Container disableGutters>
      <Row justify="flex-start" align="center" classes={{root: classes.labelRow}}>
        <Label label={label} withLeftMargin={false} withFontBold withMarginBottom={false} />
        {infoText && (
          <Wrapper className={classes.infoText}>
            <Tooltip title={infoText}>
              <Icon.InfoIcon />
            </Tooltip>
          </Wrapper>
        )}
      </Row>
      <Form.RadioGroup name={name}>
        <Row justify="flex-start">
          {radioOptions.map((option, idx) => (
            <Form.Radio key={idx} value={option.value} label={option.label} disabled={disabled} />
          ))}
        </Row>
      </Form.RadioGroup>
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  labelRow: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  infoText: {
    cursor: 'pointer',
    paddingLeft: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
}));
